import { Navigate, useLocation } from "react-router-dom";

interface LegacyRedirectProps {
  to: string;
}

/**
 * Permanent client-side redirect for legacy WordPress URLs that Google still
 * has indexed. Preserves search/hash and uses `replace` so back-button doesn't
 * loop. Crawlers that execute JS treat this as a soft 301; remaining 404s are
 * already noindex via SEOHead.
 */
const LegacyRedirect = ({ to }: LegacyRedirectProps) => {
  const { search, hash } = useLocation();
  return <Navigate to={`${to}${search}${hash}`} replace />;
};

export default LegacyRedirect;
